import {
    FaBalanceScale,
    FaChartLine,
    FaFileInvoiceDollar,
    FaHorseHead,
    FaMoneyBillWave,
    FaSeedling,
} from 'react-icons/fa';
import * as PermissionConstants from '../../context/PermissionConstants';

export const ACCOUNT_MIN_RANK = PermissionConstants.VIEW_COSTS;
// Role IDs are integers; <= 4 implements the strict role_id < 5 rule.
export const CREATE_INVOICE_MAX_RANK = 4;
export const canAccessAccountBranch = (roleId, branch) => (
    roleId !== null && roleId !== undefined && roleId !== '' &&
    Number.isInteger(Number(roleId)) && Number(roleId) <= (branch.minRank ?? ACCOUNT_MIN_RANK)
);

export const canAccessAccounts = (roleId) => (
    roleId !== null &&
    roleId !== undefined &&
    Number(roleId) <= ACCOUNT_MIN_RANK
);

export const ACCOUNT_BRANCHES = [
    {
        key: 'create-invoice', path: '/accounts/create-invoice', label: 'Create invoice PDF',
        minRank: CREATE_INVOICE_MAX_RANK,
        icon: FaFileInvoiceDollar, intent: 'Data addition',
        description: 'Choose a horse and month, generate charges, optionally split billing, and save an editable invoice as PDF.',
    },
    {
        key: 'bills',
        path: '/accounts/bills',
        label: 'Expenses',
        icon: FaFileInvoiceDollar,
        intent: 'Data addition',
        description: 'Enter, update, and archive outgoing expense rows.',
    },
    {
        key: 'invoices',
        path: '/accounts/invoices',
        label: 'Revenue',
        sidebarLabel: 'Invoices',
        icon: FaMoneyBillWave,
        intent: 'Data addition',
        description: 'Post estimates, add manual income, and finalise income months.',
    },
    {
        key: 'summary',
        path: '/accounts/summary',
        label: 'Summary',
        icon: FaBalanceScale,
        intent: 'Inspection',
        description: 'Compare income, outgoing costs, net position, and margins.',
    },
    {
        key: 'income',
        path: '/accounts/income',
        label: 'Income',
        icon: FaChartLine,
        intent: 'Inspection',
        description: 'Inspect income charts, category splits, maps, and ledgers.',
    },
    {
        key: 'outgoing',
        path: '/accounts/outgoing',
        label: 'Outgoing',
        icon: FaChartLine,
        intent: 'Inspection',
        description: 'Inspect supplier bills, categories, masks, and ledgers.',
    },
    {
        key: 'horses',
        path: '/accounts/horses',
        label: 'Horse Overviews',
        icon: FaHorseHead,
        intent: 'Inspection',
        description: 'Review per-horse income, costs, net flow, and source rows.',
    },
    {
        key: 'feed',
        path: '/accounts/feed',
        label: 'Feed',
        icon: FaSeedling,
        intent: 'Inspection',
        description: 'Compare feed purchases against expected consumption from on-farm feed ratios.',
    },
];

export const ACCOUNT_LEGACY_REDIRECTS = [
    { from: '/invoice-in', to: '/accounts/bills' },
    { from: '/invoices', to: '/accounts/bills' },
    { from: '/invoice-summary', to: '/accounts/summary' },
    { from: '/invoice-income', to: '/accounts/invoices' },
    { from: '/invoice-incoming', to: '/accounts/income' },
    { from: '/invoice-outgoing', to: '/accounts/outgoing' },
    { from: '/invoice-inspection', to: '/accounts/outgoing' },
    { from: '/invoice-horse-costs', to: '/accounts/horses' },
];
